import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from '../SvgIcon'
import { defaultFill } from '../constant'

const Television = props => (
  <SvgIcon {...props}>
    <path fill={props.fill} className="custom-fill" d="M21,3H3C1.89,3 1,3.89 1,5V17A2,2 0 0,0 3,19H8V21H16V19H21A2,2 0 0,0 23,17V5C23,3.89 22.1,3 21,3M21,17H3V5H21M16,11L9,15V7" />
  </SvgIcon>
)

Television.propTypes = {
  fill: PropTypes.string,
}

Television.defaultProps = {
  fill: defaultFill,
}

export default Television
